<template>
  <div class="intro">
    <div class="title" id="lc">
      <div class="txtStyle">公司简介</div>
      <div class="bj"></div>
    </div>
    <div class="boxin banmain videoBox">
      <video
        class="videoDB"
        id="videoDB"
        autoplay
        controls
        :src="videoSrc"
        type="video/mp4"
      ></video>
      <div class="play" v-if="playingout" id="play" @click="playVideo">
        <img
          src="@/common/images/productCenter/A1/paly.png"
          id="playbtn"
          class="playbtn"
          alt=""
        />
      </div>
      <img
        src="@/common/images/productCenter/A1/palying.png"
        class="playing"
        v-if="playing"
        alt=""
      />
    </div>
    <!-- <div class="com">
      <div>
        财富在线（深圳）科技有限公司成立于1999年，是中国证监会批准的具有《经营证券期货业务许可证》的证券投资咨询机构，中国证券业协会会员单位。
      </div>
      <div>
        在全媒体时代的大发展中，公司以媒体融合为梯，依托大数据、云计算、人工智能等技术，围绕资讯、数据、教育、投顾等互联网+金融服务方向，打造一个专业、及时、互动的移动金融服务平台。同时，公司汇聚业内高端人才，拥有经验丰富的互联网大数据研发团队、实力强大的证券顾问金服团队、行业资深金融企管团队，持续推动产品创新。公司成立全资子公司“成都市德讯数字传媒有限公司”，以实力成就投资价值，以全球财经视野赢得广大投资者的信赖，专注为投资者提供全方位金融服务。
      </div>
      <div>
        我们秉持“以客户需求为中心”的理念，持续优化用户体验，提升专业金服能力，使企业核心竞争力和品牌效应稳步提升，成为粤港澳大湾区财经行业领先的移动金融服务企业。财富在线是来自粤港澳大湾区的专业证券顾问机构。我们的愿景是为中国投资人孵化财富，为证券顾问服务金融科技领域规划崭新蓝图。
      </div>
    </div> -->
    <section class="research-background">
      <h2 class="header">一、企业简介</h2>
      <p>
        以金融科技为深耕方向，财富在线(深圳)科技有限公司在时代浪潮中持续沉淀与成长。公司核心团队汇聚金融、技术等领域专业人才，以深厚的专业知识和敏锐的行业洞察力，捕捉时代脉搏，在金融市场中稳步前行，为企业长远发展筑牢根基。
      </p>
      <p>
        公司成立于1999年7月14日，是中国证监会颁发认证的专业投资咨询机构，是中国证券业协会的会员单位。在数字经济与人工智能技术发展融合的当下，财富在线以AI科技为支点，借助大数据、云计算、人工智能等尖端技术，在资讯、数据、投顾、教育四大互联网+金融服务赛道发力，打造专业、即时且互动性强的移动金融服务生态。
      </p>
    </section>
    <section class="research-background">
      <h2 class="header">二、研发背景</h2>
      <p>在金融领域深耕二十余载，财富在线始终以专业与创新为基石，致力于为中国投资人孵化财富，为非专业投资者搭建学习与再投资平台，助力每个人成为合格的投资者。</p>
      <p>凭借深厚的行业积累，公司汇聚了业内高端人才，组建起经验丰富的互联网大数据研发团队、实力强大的证券顾问金服团队、行业资深金融企管团队。多元专业的团队架构，为公司持续推动产品创新提供了坚实保障。</p>
      <p>财富在线基于核心证券投资咨询业务，提供资讯金融、数据金融、投顾金融、教育金融等服务，构建多元化服务体系，精准匹配不同客户的差异化需求。</p>
      <p>
        在技术应用层面，公司更是走在行业前列。智能投顾系统宛如24小时在线的“金融大脑”，通过数据挖掘与精密算法，为投资者定制个性化投顾方案；区块链技术的引入，重塑了证券分析全流程，让分析报告兼具速度与精准度，助力投资者把握市场先机。
      </p>
      <p>
        专业的团队是技术落地的关键。大数据研发团队以代码与算法绘制市场趋势图谱，证券顾问团队将复杂金融逻辑转化为实用建议，金融企管团队把控战略方向，投资者教育团队则为投资者点亮认知灯塔。多方协同，让财富在线在证券咨询领域始终保持领先优势，持续为投资者创造价值。
      </p>
    </section>
    <section class="business-modules">
      <h2 class="header">三、业务模块</h2>
      <div class="card-list">
        <div class="business-card" v-for="(item,index) in businessDataList" :key="index">
          <div class="card-img">
            <img :src="item.businessimg" />
          </div>
          <div class="card-text">
            <div class="box">
              <div>{{item.nav}}</div>
              <img src="../../common/images/investCenter/line_02.png" />
            </div>
            <img src="../../common/images/investCenter/line_01.png" />
            <p>{{ item.content }}</p>
          </div>
        </div>
      </div>
    </section>
    <section class="research-background">
      <h2 class="header">四、品质金服</h2>
      <p>
        服务是公司发展的重要支撑。在财富在线科技，专业强大的团队是我们的核心竞争力。
      </p>
      <p>
        我们团队为客户勇于付出汗水，善于分析成果，始终将客户的利益放在首位，力求最大程度回报客户。我们相信，科技赋能改变投资方式，让利润回归理性。选择财富在线科技，就是选择与专业、创新和信赖同行，开启您的财富增长新征程。
      </p>
      <p>
        秉持“客户至上”的理念，公司搭建起完善的客户服务体系，专业团队7×24小时响应客户需求，从产品咨询到投顾客服，以细致、专业的服务赢得客户认可。
      </p>
      <p>
        凭借深厚的文化底蕴与积极践行社会责任，财富在线荣获多项殊荣：包括广东省“竞争力AA级企业”、腾讯广告实效增长类“最佳营销链路创新奖”、年度证券行业最佳全域营销应用奖、Boss直聘王者之舟“最爱人才雇主”，以及深圳国际人工智能创新大会“链接者”称号等。
      </p>
    </section>
    <section class="corporate-culture">
      <h2 class="header">五、企业文化</h2>
      <div class="culture-list">
        <div class="culture-card" v-for="(item,index) in cultureDataList" :key="index">
          <div class="card-img">
            <img :src="item.cultureimg" alt="企业使命" />
          </div>
          <div class="card-text">
            <h3>{{item.nav}}</h3>
            <ul>
              <li v-for="(val,index) in item.paragraphs" :key="index">{{val}}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- <div class="threebox">
      <div class="tbox">
        <div class="tbox_t">经营理念</div>
        <div class="tbox_p tbox_p_c">以客户需求为中心</div>
      </div>
      <div class="tbox">
        <div class="tbox_t">企业使命</div>
        <div class="tbox_p">
          致力于为中国投资人孵化财富，为非专业投资人搭建学习平台和再投资通道，让每个人都能成为合格的投资者
        </div>
      </div>
      <div class="tbox">
        <div class="tbox_t">企业愿景</div>
        <div class="tbox_p">力争成为粤港澳大湾区专业证券顾问行业标杆</div>
      </div>
    </div>
    <div class="borImg"></div>
    <div class="icon">
      <div class="iconCard">
        <div class="iconImg"></div>
        <div class="iconTXT">
          <div class="iconTXT1">资讯金融</div>
          <div class="iconTXT2">权威的财经资讯移动平台</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="iconCard">
        <div class="iconImg" id="iconImg2"></div>
        <div class="iconTXT" style="width: 160px">
          <div class="iconTXT1">数据金融</div>
          <div class="iconTXT2">高度整合实时行情数据</div>
        </div>
      </div>
      <div class="line"></div>

      <div class="iconCard">
        <div class="iconImg" id="iconImg3"></div>
        <div class="iconTXT">
          <div class="iconTXT1">教育金融</div>
          <div class="iconTXT2">专业轻松的投资学习平台</div>
        </div>
      </div>
      <div class="line"></div>

      <div class="iconCard">
        <div class="iconImg" id="iconImg4"></div>
        <div class="iconTXT">
          <div class="iconTXT1">投顾金融</div>
          <div class="iconTXT2">多维度投顾服务管理系统</div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "A01_gsjj",
  data() {
    return {
      // videoSrc: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/about.mp4",
      videoSrc: "https://marketingvideo-news.oss-cn-shenzhen.aliyuncs.com/%E5%85%AC%E5%8F%B8%E5%AE%A3%E4%BC%A0%E7%89%87%20%E8%80%81%E5%B8%88%E4%BB%8B%E7%BB%8D%E8%A7%86%E9%A2%91/%E3%80%90%E5%85%AC%E5%8F%B8%E5%AE%A3%E4%BC%A0%E7%89%87%E3%80%91%E8%B4%A2%E5%AF%8C%E5%9C%A8%E7%BA%BF03.mp4",
      playingout: true,
      playing: false,
      businessDataList:[
        {
          businessimg: require('../../common/images/investCenter/business_01.png'),
          nav: '资讯金融',
          content: '依托公司投研专业能力，同时借助权威媒体实时资讯，构建全面、丰富、专业、实时的证券市场资讯体系，包含宏观分析、行业动态、公司事件、投研报告、策略分析等多维视角价值资讯内容。'
        },
        {
          businessimg: require('../../common/images/investCenter/business_02.png'),
          nav: '数据金融',
          content: '通过大数据、人工智能、云计算等金融科技的运用，进一步提升数据洞察能力和深度挖掘数据价值，从投资决策、客户服务、产品创新、风险管理等方面提供全场景数据服务解决方案。'
        },
        {
          businessimg: require('../../common/images/investCenter/business_03.png'),
          nav: '投顾金融',
          content: '以客户服务为中心，专注客户需求，全面把握用户、产品、市场之间的联系，结合团队专业知识，运用金融科技工具为客户提供专业、持续的投资咨询服务。'
        },
        {
          businessimg: require('../../common/images/investCenter/business_04.png'),
          nav: '教育金融',
          content: '通过自研的多层次金融价值知识体系课程，创建开放共享的智慧金融教育生态，以科技运用照亮普惠金融教育之路，帮助投资者树立理性投资理念，强化风险意识，提升全民金融素养。'
        },
      ],
      cultureDataList:[
        {
          cultureimg: require('../../common/images/investCenter/culture_01.png'),
          nav: '企业使命',
          paragraphs: [
            '•“科技赋能财富增长，价值创造美好生活”',
            '•通过科学技术创新优化财富管理流程，帮助用户实现资产增值，推动金融服务专业化。'
          ]
        },
        {
          cultureimg: require('../../common/images/investCenter/culture_02.png'),
          nav: '企业愿景',
          paragraphs: [
            '•“成为领先的科技驱动型证券财富服务平台”',
            '•以技术为核心竞争力，打造智能化、数字化的财富生态，引领行业向高效、透明的方向发展。'
          ]
        },
        {
          cultureimg: require('../../common/images/investCenter/culture_03.png'),
          nav: '企业价值观',
          paragraphs: [
            '•科技创新为本：深耕技术突破与数据创新，保持行业前瞻性。',
            '•客户价值优先：以用户需求为核心，建立长期信任。',
            '•担当专业研究：恪守合规底线。'
          ]
        },
        {
          cultureimg: require('../../common/images/investCenter/culture_04.png'),
          nav: '企业精神',
          paragraphs: [
            '•专业、进取、务实。',
            '•以专业研究推动发展，以远大目标驱动创新，以脚踏实地落地服务方案，拒绝空谈。'
          ]
        },
      ]
    };
  },
  mounted() {
    this.playState();
  },
  methods: {
    //大德精研视频播放
    playVideo: function () {
      let video = document.getElementById("videoDB");
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },
    playState: function () {
      let that = this;
      let ele = document.getElementById("videoDB");
      ele.addEventListener("play", function () {
        //播放开始执行的函数
        //console.log(1);
        that.playing = true;
        that.playingout = false;
        let s = setTimeout(function () {
          that.playing = false;
          clearTimeout(s);
        }, 1000);
      });
      ele.addEventListener("pause", function () {
        //暂停开始执行的函数
        //console.log(0);
        that.playingout = true;
      });
    },
  },
};
</script>
<style scoped>
.intro {
  width: 1170px;
  overflow: hidden;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 48px;
  color: #333333;
  opacity: 1;
  margin-left: 236px;
}
.title {
  position: relative;
  width: 710px;
  height: 56px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  font-size: 40px;
  text-align: center;
  line-height: 56px;
  margin: 0 auto;
}
.txtStyle {
  line-height: 56px;
}
.bj {
  position: absolute;
  top: 20px;
  /* left: 598px; */
  width: 710px;
  height: 16px;
  background: url("../../common/images/investCenter/textBj.png") no-repeat;
}
.com {
  width: 1146px;
  margin: 0 auto;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #333333;
  opacity: 1;
  text-align: left;
}
.borImg {
  width: 700px;
  height: 19px;
  background: url("../../common/images/about/A01_gsjj/borImg.png") no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 40px;
}
.icon {
  width: 100%;
  display: flex;
  margin: 0 auto;
  margin-top: 38px;
}
.iconCard {
  display: flex;
}
.iconImg {
  width: 60px;
  height: 60px;
  background: url("../../common/images/about/A01_gsjj/icon1.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 20px;
}
.iconTXT {
  width: 176px;
  text-align: left;
}
.iconTXT1 {
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 30px;
  color: #333333;
  opacity: 1;
}
.iconTXT2 {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #505050;
  opacity: 0.88;
}
.line {
  width: 0px;
  height: 59px;
  border: 1px solid #dbdbdb;
  opacity: 1;
  margin: 5px 26px 0 26px;
}
#iconImg2 {
  height: 65px;
  background: url("../../common/images/about/A01_gsjj/icon2.png") no-repeat;
  background-size: 100% 100%;
}
#iconImg3 {
  background: url("../../common/images/about/A01_gsjj/icon3.png") no-repeat;
  background-size: 100% 100%;
}
#iconImg4 {
  background: url("../../common/images/about/A01_gsjj/icon4.png") no-repeat;
  background-size: 100% 100%;
}
.video {
  width: 980px;
  height: 551px;
  background-color: #ccf;
  margin: 0px 0 60px 152px;
}

.videoBox {
  position: relative;
  width: 980px;
  height: 550px;
  margin: 30px auto;
}
.videoDB {
  width: 100%;
  height: 100%;
}
.videoBox .play {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 400px;
  background: linear-gradient(rgba(80, 80, 80, 0.3), rgba(80, 80, 80, 0));
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  cursor: pointer;
}
.videoBox .playbtn {
  display: block;
  width: 90px;
  height: 90px;
  margin-top: 120px;
}
.videoBox .playing {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -45px;
  margin-top: -60px;
}
.threebox {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-top: 60px;
  margin-bottom: 40px;
}
.tbox {
  width: 310px;
  height: 350px;
  background: url("../../common/images/about/A01_gsjj/threebox.png");
}
.tbox:nth-child(2) {
  margin: 0 80px;
}
.tbox_t {
  width: 104px;
  height: 37px;
  font-size: 26px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 37px;
  margin: 0 auto;
  margin-top: 40px;
}
.tbox_p {
  width: 224px;
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #4d4d4d;
  line-height: 34px;
  margin: 0 auto;
  margin-top: 24px;
  text-align: left;
}
.tbox_p_c {
  text-align: center;
}

.header {
  font-size: 30px;
  margin-bottom: 15px;
  text-align: left;
  color: rgba(29, 29, 29, 1);
}

.research-background {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

.research-background p {
  font-size: 20px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 1.8;
  margin-bottom: 16px;
  text-align: left;
}

.research-background p:last-child {
  margin-bottom: 0;
}

/* 业务模块 */
.business-modules {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

.card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.business-card {
  display: flex;
  width: calc(50% - 10px);
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 6px  rgba(0, 0, 0, 0.16);
  overflow: hidden;
}

.card-img {
  width: 160px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-text {
  padding: 13px 20px;
  flex: 1;
  text-align: left;
}

.box{
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.box >img {
  width: 74px;
  height: 22px;
}

.card-text div {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 6px;
  color: rgba(51, 51, 51, 1);
}

.card-text img {
  display: block;
  margin-top: -5px;
}

.card-text p {
  margin-top: 14px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: rgba(80, 80, 80, 1);
}

/* 企业文化模块 */
.corporate-culture {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

.culture-list {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.culture-card {
  flex: 1;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  box-shadow: 0px 2px 6px  rgba(0, 0, 0, 0.16);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 卡片图片区 */
.culture-card .card-img {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.culture-card .card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 卡片文字区 */
.culture-card .card-text {
  padding: 20px;
  flex: 1;
}

.culture-card .card-text h3 {
  font-size: 24px;
  font-weight: 600;
  line-height: 35px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}

.culture-card .card-text ul{
  margin-top: 10px;
}

.culture-card .card-text ul li {
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 28px;
  color: #505050;
}

/* 最后一个列表项，取消底部间距 */
.culture-card .card-text ul li:last-child {
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/aboutS/A01_gsjj.vue